const LocalStorageHelper = {
	/**
	 * Get the bearer token from local storage
	 * @returns {String} returns empty string if the item is not present
	 */
	getToken: () => {
		return localStorage.getItem('path_department_admin_token');
	},

	/**
	 * Set the bearer token to local storage
	 * @param {String} token 
	 * @returns {void}
	 */
	setToken: (token) => {
		try {
			localStorage.setItem('path_department_admin_token', token);
		} catch (error) {
			console.log(error);
		}
	},

	/**
	 * Remove bearer token item from local storage
	 * @returns {void}
	 */
	removeToken: () => {
		localStorage.removeItem('path_department_admin_token');
	},

	/**
	 * Set the admin data to the local storage
	 * @param {Object} admin
	 * @returns {void}
	 */
	setAdmin: (admin) => {
		// Wrap in a try-catch block to capture error when JSON.stringify fails
		try {
			localStorage.setItem('path_department_admin', JSON.stringify(admin));
		} catch (error) {
			console.log(error);
		}

	},

	/**
	 * Get admin data from local storage
	 * @returns {Object}
	 */
	getAdmin: () => {
		// Wrap in a try-catch block to capture error when JSON.parse fails
		try {
			const jsonAdmin = JSON.parse(localStorage.getItem('path_department_admin'));
			return jsonAdmin;
		} catch (error) {
			console.log(error);
		}
	},

	/**
	 * Remove admin item from local storage
	 * @returns {void}
	 */
	removeAdmin: () => {
		localStorage.removeItem('path_department_admin');
	},

	/**
	 * Set the admin department data to the local storage
	 * @param {Array} departments
	 * @returns {void}
	 */
	setAdminDepts: (departments) => {
		// Wrap in a try-catch block to capture error when JSON.stringify fails
		try {
			localStorage.setItem('path_department_admin_depts', JSON.stringify(departments));
		} catch (error) {
			console.log(error);
		}

	},

	/**
	 * Get it admin department data from local storage
	 * @returns {Array}
	 */
	getAdminDepts: () => {
		// Wrap in a try-catch block to capture error when JSON.parse fails
		try {
			const jsonAdminDepts = JSON.parse(localStorage.getItem('path_department_admin_depts'));
			return jsonAdminDepts || [];
		} catch (error) {
			console.log(error);
		}
	},

	/**
	 * Remove admin department item from local storage
	 * @returns {void}
	 */
	removeAdminDepts: () => {
		localStorage.removeItem('path_department_admin_depts');
	},

	/**
	 * Set the current admin department data to the local storage
	 * @param {String} departmentId
	 * @returns {void}
	 */
	setCurrentAdminDept: (departmentId) => {
		localStorage.setItem('path_current_department_admin_dept', departmentId);
	},

	/**
	 * Get it current admin department data from local storage
	 * @returns {String}
	 */
	getCurrentAdminDept: () => {
		// Get selected department
		const currentDepartment = localStorage.getItem('path_current_department_admin_dept');
		if (currentDepartment) {
			return currentDepartment;
		}

		// Fetch the first one
		const departments = LocalStorageHelper.getAdminDepts();
		if (departments.length === 0) {
			return null;
		}

		const department = departments[0];
		LocalStorageHelper.setCurrentAdminDept(department._id);

		return department._id;
	},

	/**
	 * Remove current admin department item from local storage
	 * @returns {void}
	 */
	removeCurrentAdminDepts: () => {
		localStorage.removeItem('path_current_department_admin_dept');
	}
};

export default LocalStorageHelper;